import {extendObservable, toJS} from 'mobx'
import firebase from '../firebase'
import * as helpers from '../lib/HelperFunctions'
import Logger from './Logger'

class TeamStore {
    constructor(authStore, notificationStore) {
        extendObservable(this, {
            secondaryApp: null,
        })
        this.authStore = authStore
        this.notificationStore = notificationStore
    }
    addMemberToTeam(memberEmail, teamKey, name){
        const authUser = this.authStore.authUser()
        let thing = this
        let userKey, teamName
        let members = {}
        let userFound = -1
        memberEmail = memberEmail.toLowerCase()
        return new Promise((resolve,reject) => {
            firebase.database().ref().child('users').orderByChild("email").equalTo(memberEmail).once('value', function (userSnap) {
                return new Promise((resolve,reject) => {
                    if(userSnap.exists()){
                        let user = userSnap.val()
                        userKey = Object.keys(user)[0]
                        let userObj = user[Object.keys(user)[0]]
                        //check if they are already on another team (currently primaryTeam will be just overridden)
                        if(userObj.hasOwnProperty('assignedTeams')){
                            userObj.assignedTeams.forEach((theTeam) => {
                                if(theTeam.teamKey === teamKey){
                                    userFound = 0
                                    return reject('User is already on the team!')
                                }
                            })
                        }
                        else{
                            userObj['assignedTeams'] = []
                        }

                        if (userFound === -1){
                            //send invite that they have been added to team
                            firebase.database().ref().child('teams/'+teamKey+'/name').once('value', teamNameSnap => {
                                if(teamNameSnap.exists()){
                                    teamName = teamNameSnap.val()
                                    var newInvite = {
                                        recipient: memberEmail,
                                        host: authUser.email,
                                        hostName: authUser.displayName,
                                        inviteCreated: firebase.database.ServerValue.TIMESTAMP,
                                        fullName: userObj.displayName,
                                        existingUser: true,
                                        teamName: teamName,
                                    }
                                    firebase.database().ref().child('invites').push(newInvite)
                                }
                            })
                            resolve(userObj.displayName)
                        }
                    }else{
                        console.log('user NOT found, creating user account and adding /invite')
                        // console.log('firebase.app().options',firebase.app().options)
                        //inspired by: https://stackoverflow.com/a/38013551/67555
                        if(!thing.secondaryApp)
                            thing.secondaryApp = firebase.initializeApp(firebase.app().options, "other")
                        let temporaryPassword = Math.random().toString(36).slice(-8)
                        return thing.secondaryApp.auth().createUserWithEmailAndPassword(memberEmail, temporaryPassword)
                        .then(function (firebaseUser) {
                            userKey = firebaseUser.uid
                            console.log("User " + firebaseUser.uid + " created successfully!")
                            firebase.database().ref().child('teams/'+teamKey+'/name').once('value', teamNameSnap => {
                                if(teamNameSnap.exists()){
                                    teamName = teamNameSnap.val()
                                    var newInvite = {
                                        recipient: memberEmail,
                                        host: authUser.email,
                                        hostName: authUser.displayName,
                                        inviteCreated: firebase.database.ServerValue.TIMESTAMP,
                                        fullName: memberEmail.split('@')[0] ? memberEmail.split('@')[0] : 'unknown',
                                        existingUser: false,
                                        temporaryPassword: temporaryPassword, 
                                        teamName: teamName,
                                        teamKey: teamKey,
                                    }
                                    firebase.database().ref().child('invites').push(newInvite)
                                }
                            })    
                            //I don't know if the next statement is necessary 
                            thing.secondaryApp.auth().signOut()
                            resolve(memberEmail.split('@')[0])
                        }).catch(function (error) {
                            console.error(error)
                        })
                    }
                }).then((userDisplayName) => {
                    if (userFound === -1){
                        thing.notificationStore.createNotificationAboutJoinedTeam(teamName, userKey, authUser.displayName + ' invited you to join their team.', 'personalInvitation')
                        thing.notificationStore.createNotificationToTeamMembersInTeam(teamKey,thing.authStore.authUser().displayName + ' invited '+userDisplayName+' to your team',-1)
                    }
                    firebase.database().ref().child('teams/'+teamKey+'/members').once('value', membersSnap => {
                        if(membersSnap.exists()){
                            members = membersSnap.val()
                        }
                        members[userKey]=true
                        membersSnap.ref.update(members)
                    }).then(() => {
                        if (userFound === -1){
                                firebase.database().ref().child('users').child(userKey).update({primaryTeam:teamKey})
                                //This function is used in order to save the latest version of the team members
                                //since while the new member is being added, this informs that the newest version
                                //of members should be used and which should avoid (sometimes for now) 'loading...' to appear until the page is refreshed.
                                return firebase.database().ref().child('teams/'+teamKey+'/members').set(members)
                        }
                    }).then(() => {
                        return resolve()
                    })
                },rejectErr => {
                    return reject(rejectErr)
                })
            })
        })
    }
    addReferenceOfTheIdea(teamId, ideaKey){
        firebase.database().ref().child('teams/'+teamId+'/newIdeas/').update({[ideaKey]:true})
    }
    addReferenceOfTheIdeaToUsers(teamId, ideaKey, admins, idea){
        let listOfAdmins = Object.keys(admins)
        let shareList = toJS(idea.team)
        var theUser = this.authStore.authUser()
        //Checking if there were existing collaborators already
        if(!shareList){
            shareList = []
        }
        listOfAdmins.forEach((adminUserKey, index) => {
            firebase.database().ref('/users/' + adminUserKey).once('value').then(userSnap => {
                if(userSnap.exists()){
                    let userObject = userSnap.val()
                    firebase.database().ref().child('users/'+adminUserKey+'/ideas/').update({[ideaKey]:true})
                    if(theUser.uid !== adminUserKey) {
                        shareList.push({email: userObject.email, fullName: userObject.displayName, photoURL: userObject.photoURL, userId: userSnap.key})
                    }
                    if(index === listOfAdmins.length-1 && shareList.length !== 0){
                        firebase.database().ref().child('/ideas/' + ideaKey + '/team/').set(shareList)
                    }
                }
            })
        })
    }
    removeMemberFromTeam(uid, teamKey){
        let thing = this
        firebase.database().ref().child('users/'+uid).once('value', function (userSnap) {
            if(userSnap.exists()){
                let user = userSnap.val()
                thing.notificationStore.createNotificationToTeamMembersInTeam(teamKey,thing.authStore.authUser().displayName + ' removed member '+uid+' from your team.', uid)//TODO: content TBD
                firebase.database().ref().child('teams/'+teamKey+'/members').once('value', membersSnap => {
                    let members = membersSnap.val()
                    if(members.hasOwnProperty(uid)){
                        delete members[uid]
                    }
                    membersSnap.ref.set(members)
                }).then(() => {
                    userSnap.ref.child('primaryTeam').remove()
                    if (user.hasOwnProperty('assignedTeams')){
                        user.assignedTeams.forEach((theTeam, index) => {
                            if (theTeam.teamKey === teamKey){
                                user.assignedTeams.splice(index, 1)
                                userSnap.ref.child('assignedTeams').set(user.assignedTeams)
                                if (user.assignedTeams !== undefined){
                                    if (user.assignedTeams.length > 0){
                                        userSnap.ref.child('primaryTeam').set(user.assignedTeams[0].teamKey)
                                    }
                                }
                            }
                        })
                    }
                    else return console.log('assignedTeam not found or already removed')
                })
            }else{
                console.error('user NOT found: '+uid)          
            }
        })     
    }
    removeTeamFromIdea(teamKey, ideaKey, theIdea){
        let thing = this
        firebase.database().ref().child('teams/'+teamKey).once('value', function (teamSnap) {
            let exists = (teamSnap.val() !== null)
            if (exists) {
                thing.notificationStore.createNotificationToTeamMembers(
                    ideaKey, 
                    thing.authStore.authUser().displayName + ' unshared this idea with your team', 
                    theIdea.owner, 
                    toJS(theIdea.team),
                    null,
                )

                // console.log('team found',teamSnap.val())
                let team = teamSnap.val()
                let ideas = {}
                if(team.hasOwnProperty('ideas')){
                    ideas = team.ideas
                }
                delete ideas[ideaKey]
                team.ideas = ideas
                teamSnap.ref.parent.update({[teamKey]:team})
            }
        }).then(ret => {
            let shareList = toJS(theIdea.team)
            shareList.forEach((member, index) => {
                if(member.hasOwnProperty('teamId')){
                    if(member.teamId === teamKey){
                        shareList.splice(index,1)
                    }else{
                        //console.error('other team found!!!')
                    }
                }//else skip individuals in team
            })
            firebase.database().ref().child('ideas/'+ideaKey+'/team/').set(helpers.cleanObj(shareList))
            firebase.database().ref().child('ideas/'+ideaKey+'/lastUpdated').set(firebase.database.ServerValue.TIMESTAMP)
        })
    }
    addTeamAsMemberOfIdea(ideaKey, newTeam, theIdea){
        //store the newTeam as part of the idea team & add the ideaKey under all team-members-/user/ideas
        let thing = this
        let shareList = null
        firebase.database().ref().child('teams/'+newTeam.key).once('value', function (teamSnap) {
            let exists = (teamSnap.val() !== null)
            if (exists) {
                // console.log('team found',teamSnap.val())
                let team = teamSnap.val()
                let ideas = {}
                if(team.hasOwnProperty('ideas')){
                    ideas = team.ideas
                }
                ideas[ideaKey] = true
                team.ideas = ideas
                teamSnap.ref.parent.update({[newTeam.key]:team})
            }
        }).then(ret => {
            shareList = toJS(theIdea.team)
            if(!shareList)
                shareList = []
            shareList.push({teamId:newTeam.key, fullName:newTeam.name, photoURL:newTeam.photoURL})
            firebase.database().ref().child('ideas/'+ideaKey+'/team/').update(helpers.cleanObj(shareList))
        }).then(res => {
            const authUser = thing.authStore.authUser()
            thing.notificationStore.createNotificationToTeamMembers(
                ideaKey, 
                authUser.displayName + ' shared this idea with your team', 
                theIdea.owner, 
                shareList,
                null)
        })
        //TODO: send invites?
    }
    assignTeamToIdea(teamsID, ideaKey, theIdea){
        let teamObject = {}
        let teamKey = teamsID
            firebase.database().ref().child('teams/' + teamKey).once('value', aTeam => {
                let ptm = aTeam.val()
                ptm['key'] = aTeam.key
                let users = {}
                // console.log('My primary team:',this.auth.primaryTeam)
                let members = {}
                if(ptm.hasOwnProperty('members')){
                    members = ptm.members
                }
                let requests = Object.keys(members).map((uid) => {
                    return firebase.database().ref().child('users/' + uid).once('value').then(aUser => {
                        // console.log('got user',aUser.val().displayName)
                        users[uid] = aUser.val()
                    })
                })
                Promise.all(requests).then(() => {
                    ptm['users'] = users
                    teamObject = ptm
                    this.addTeamAsMemberOfIdea(ideaKey, teamObject, theIdea)
                    Logger.trackEvent('onAddTeamAsMember', 'ideaKey', ideaKey)
                    firebase.database().ref().child('ideas/'+ideaKey+'/lastUpdated').set(firebase.database.ServerValue.TIMESTAMP)
            })
        })
    }
    findTeam(teamKey, userID){
        let isFound = false
        firebase.database().ref().child('teams/'+teamKey).once('value', function (teamSnap) {
            if (teamSnap.exists()) {
                let team = teamSnap.val()
                Object.keys(team.members).forEach((member, index) => {
                    if (member === userID){
                        return isFound = true
                    }
                })
            }
        })
        return isFound
    }
}

export default TeamStore


// WEBPACK FOOTER //
// ./src/stores/TeamStore.js